import { Component, Inject, Renderer2 } from '@angular/core';
import * as AOS from 'aos';

import { Title, Meta } from '@angular/platform-browser';

import { Constants } from '../../common/constants';
import { SeoService } from 'src/app/common/seo.service';
import { DOCUMENT } from '@angular/common';
@Component({
  selector: 'app-postpandamic-blog',
  templateUrl: './postpandamic-blog.component.html',
  styleUrls: ['./postpandamic-blog.component.css']
})
export class PostpandamicBlogComponent {
  baseUrl=Constants.baseUrl;
  constructor(
    private titleService: Title,
    private metaService: Meta,private _renderer2: Renderer2,private seoService:SeoService,
    @Inject(DOCUMENT) private _document: Document
  ) {}

  ngOnInit(): void {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
{
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/postpandamic/"
  },
  "headline": "The new wave of Digital Marketing in the Post-Pandemic world",
  "description": "The world was already progressing into digital; COVID-19 accelerated the pace. The acceleration was such that it upended the way businesses worked. One year into the episode and the old digital methods seem to have lost their power.",
  "image": "https://mitresource.com/assets/images/blogs/digitalmarketingpostpandemic.webp",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT Resources",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2022-11-11"
}`;
   
    this._renderer2.appendChild(this._document.head, script);
    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();
  
  }

  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('The new wave of Digital Marketing in the Post-Pandemic world');

    this.metaService.addTags([
      { name: 'description', content: 'The world was already progressing into digital; COVID-19 accelerated the pace!' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'The new wave of Digital Marketing in the Post-Pandemic world' },
      { property: 'og:url', content: 'https://mitresource.com/postpandamic/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/blogs/digitalmarketingpostpandemic.webp' },
      { property: 'og:description', content: 'The world was already progressing into digital; COVID-19 accelerated the pace.' },
    ]);
  }
}
